import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faLocationDot, faClock, faHeart } from "@fortawesome/free-solid-svg-icons";
import { GlobalData } from "../assets/data/GlodalData";
import NavbarLogo from "../components/Navbar/csdv2Logo.png";

const Contactus = () => {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      {/* Hero Section */}
      <section className="relative py-32 gradient-bg text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white to-transparent" />
        <div className="container mx-auto px-6 text-center relative z-10">
          <h1 className="text-5xl md:text-8xl font-black mb-6 tracking-tighter flex flex-col md:flex-row items-center justify-center gap-6">
            <img src={NavbarLogo} alt="Logo" className="hidden md:block md:h-32 w-auto" />
            <span>Get in <span className="italic opacity-80">Touch</span></span>
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-light opacity-90 leading-relaxed">
            Whether you need help with a child’s treatment or want to support our mission, we are here to listen.
          </p>
        </div>
      </section>

      {/* Main Contact Section */}
      <section className="py-24 -mt-16 relative z-10">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-12">

            {/* Contact Info Cards */}
            <div className="lg:w-1/3 space-y-6">
              {[
                { icon: faPhone, color: "text-brand-red", bg: "bg-brand-red/10", label: "Phone", value: GlobalData.company.companyPhone, link: `tel:${GlobalData.company.companyPhone}` },
                { icon: faEnvelope, color: "text-brand-gold", bg: "bg-brand-gold/10", label: "Email", value: GlobalData.company.companyEmail, link: `mailto:${GlobalData.company.companyEmail}` },
                { icon: faLocationDot, color: "text-brand-gold", bg: "bg-brand-gold/10", label: "Office", value: GlobalData.company.companyAddress },
                { icon: faClock, color: "text-brand-gold", bg: "bg-brand-gold/10", label: "Hours", value: "Mon - Sat: 9:00 AM - 6:00 PM" }
              ].map((info, i) => (
                <div key={i} className="p-8 glass-card bg-white border-none shadow-xl flex items-start gap-6 group hover:-translate-y-2 transition-all">
                  <div className={`w-14 h-14 ${info.bg} ${info.color} rounded-2xl flex items-center justify-center flex-none group-hover:scale-110 transition-transform shadow-md text-xl`}>
                    <FontAwesomeIcon icon={info.icon} />
                  </div>
                  <div>
                    <h3 className="font-black text-slate-400 uppercase text-[10px] tracking-[0.3em] mb-2">{info.label}</h3>
                    {info.link ? (
                      <a href={info.link} className="text-slate-900 font-bold text-lg hover:text-brand-red transition-colors break-all">
                        {info.value}
                      </a>
                    ) : (
                      <p className="text-slate-900 font-bold text-lg leading-relaxed">{info.value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Contact Form */}
            <div className="lg:w-2/3 p-10 md:p-16 glass-card bg-white border-none shadow-[0_50px_100px_-20px_rgba(0,0,0,0.1)] rounded-[3rem]">
              <h2 className="text-4xl font-black text-slate-900 mb-10 tracking-tighter uppercase">Send a <span className="text-brand-red">Message</span></h2>
              <form className="space-y-8">
                <div className="grid md:grid-cols-2 gap-8">
                  <div>
                    <label className="block text-xs font-black text-slate-400 uppercase tracking-[0.2em] mb-3 ml-2">Your Name</label>
                    <input
                      type="text"
                      className="w-full px-6 py-4 bg-brand-beige border border-slate-100 rounded-2xl focus:outline-none focus:ring-4 focus:ring-brand-red/10 transition-all text-slate-900 font-bold placeholder:text-slate-300"
                      placeholder="e.g. John Doe"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-black text-slate-400 uppercase tracking-[0.2em] mb-3 ml-2">Your Email</label>
                    <input
                      type="email"
                      className="w-full px-6 py-4 bg-brand-beige border border-slate-100 rounded-2xl focus:outline-none focus:ring-4 focus:ring-brand-red/10 transition-all text-slate-900 font-bold placeholder:text-slate-300"
                      placeholder="john@example.com"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-black text-slate-400 uppercase tracking-[0.2em] mb-3 ml-2">Subject</label>
                  <select className="w-full px-6 py-4 bg-brand-beige border border-slate-100 rounded-2xl focus:outline-none focus:ring-4 focus:ring-brand-red/10 transition-all text-slate-900 font-bold appearance-none">
                    <option>General Inquiry</option>
                    <option>Request Medical Help</option>
                    <option>Donation Questions</option>
                    <option>Volunteer with Us</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-black text-slate-400 uppercase tracking-[0.2em] mb-3 ml-2">Message</label>
                  <textarea
                    className="w-full px-6 py-4 bg-brand-beige border border-slate-100 rounded-2xl focus:outline-none focus:ring-4 focus:ring-brand-red/10 transition-all text-slate-900 font-bold placeholder:text-slate-300 min-h-[150px]"
                    placeholder="How can we help you?"
                  />
                </div>
                <button
                  type="submit"
                  className="w-full py-5 gradient-bg text-white font-black text-xl rounded-2xl shadow-2xl hover-glow transform hover:scale-105 transition-all active:scale-95 uppercase tracking-tighter"
                >
                  SEND MESSAGE
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-24 bg-brand-beige">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-black text-slate-900 tracking-tighter uppercase mb-4">Visit <span className="text-brand-red">Us</span></h2>
            <p className="text-slate-500 font-bold uppercase tracking-widest text-xs">{GlobalData.company.companyAddress}</p>
          </div>
          <div className="w-full h-[500px] bg-white rounded-[4rem] overflow-hidden shadow-2xl relative group border-8 border-white">
            <iframe
              title="location"
              className="w-full h-full grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15201.299!2d83.298!3d17.723!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3943!2sVizag!5e0!3m2!1sen!2sin!4v1"
              frameBorder="0" style={{ border: 0 }} allowFullScreen="" aria-hidden="false" tabIndex="0"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="py-32 bg-slate-900 text-white text-center">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl md:text-6xl font-black tracking-tighter mb-12 max-w-4xl mx-auto leading-tight italic opacity-90">
            Have a child in need? <span className="text-brand-red">Don't wait.</span>
          </h2>
          <Link to="/donate-now" className="inline-block px-12 py-5 gradient-bg text-white rounded-full font-black text-xl hover-glow transform hover:scale-105 transition-all shadow-2xl uppercase tracking-tighter">
            Get Immediate Help <FontAwesomeIcon icon={faHeart} className="ml-2" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Contactus;